export default __webpack_public_path__ + "static/media/pp-white.8e7f2cc7.svg";